import { Component, effect, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nService } from '@core/i18n';
import { CurrentUserService, LayoutService, NavigationHistoryService } from '@shared/services';
import { CurrentUser, ToasterPositionEnum } from '@shared/types';
import { LoaderComponent } from '@ui-kit/miscs/loader/loader.component';
import { ToastModule } from 'primeng/toast';
import { BreadcrumbsComponent, FooterComponent, HeaderComponent, SidebarComponent } from './layout';
import { NgClass } from '@angular/common';
import { MobileMenuComponent } from '@layout/mobile-menu/mobile-menu.component';
import { ErrorPageComponent, UnauthorizedPageComponent } from '@shared/pages';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        HeaderComponent,
        LoaderComponent,
        RouterModule,
        FooterComponent,
        ToastModule,
        SidebarComponent,
        NgClass,
        BreadcrumbsComponent,
        MobileMenuComponent,
        UnauthorizedPageComponent,
        ErrorPageComponent,
    ],
    standalone: true,
})
export class AppComponent {
    navHistoryService = inject(NavigationHistoryService);
    private currentUserService = inject(CurrentUserService);
    private i18nService = inject(I18nService);
    private layoutService = inject(LayoutService);

    isLoading = signal(true);
    hasError = signal(false);
    currentUser = signal<CurrentUser | null>(null);
    isUnauthorized = signal(false);
    isSidebarCollapsed = signal(false);

    readonly toasterPositions = ToasterPositionEnum;

    constructor() {
        this.layoutService.isSidebarCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isSidebarCollapsed.set(isCollapsed);
        });

        this.i18nService.initialize();

        effect(() => {
            const user = this.currentUserService.currentUser();
            const isUnauthorized = this.currentUserService.isUnauthorized();
            const hasError = this.currentUserService.hasError();

            this.currentUser.set(user);
            this.isUnauthorized.set(isUnauthorized);
            this.hasError.set(hasError);

            if (user.userId || isUnauthorized || hasError) {
                this.isLoading.set(false);
            }
        });
    }
}
